// Pages through `total` documents with skip/take, de-duplicating by _id.
//
// A page that comes back as anything other than an array (an error body, usually
// because the response was too big for the API) is retried at half the size, and
// the smaller size is kept for the rest. If a single document still fails, this
// throws instead of quietly returning a partial list.
export async function fetchAllPages({ label, total, piece_size, getPage, onProgress }: {
  label: string,
  total: number,
  piece_size: number,
  getPage: (skip: number, take: number) => Promise<any>,
  onProgress?: (fraction: number) => void,
}): Promise<any[]> {
  const all: any[] = [];
  const seen_ids = new Set<string>();
  let take = Math.max(1, piece_size);
  let last_added = -1;
  while (all.length < total && last_added !== 0) {
    if (onProgress) {
      onProgress(all.length / total);
    }
    last_added = 0;
    const response = await getPage(all.length, take);
    const body = response && !response.error && !response.message ?
      (response.objects ?? response) : null;
    if (!Array.isArray(body)) {
      console.error(`${label}: page of ${take} at ${all.length} failed`, response);
      if (take === 1) {
        throw new Error(`Couldn't load ${label} (failed at ${all.length} of ${total})`);
      }
      take = Math.max(1, Math.floor(take / 2));
      last_added = -1;
      continue;
    }
    for (const obj of body) {
      if (!seen_ids.has(obj._id)) {
        all.push(obj);
        seen_ids.add(obj._id);
        last_added++;
      }
    }
  }
  return all;
}
